import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { packCategoryService } from "../../../services/settings-services";

const initialState = {
  packCategories: [],
  status: null,
  error: null,
  trigger: 0,
};

const getAllPackCategories = createAsyncThunk(
  "packCategorySlice/getAllPackCategories",
  async (_, { rejectWithValue }) => {
    try {
      return await packCategoryService.getAll();
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || "Something went wrong");
    }
  }
);

const packCategorySlice = createSlice({
  name: "packCategorySlice",
  initialState,
  reducers: {
    changeTrigger: (state) => {
      state.trigger = state.trigger + 1;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAllPackCategories.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(getAllPackCategories.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.packCategories = action.payload;
      })
      .addCase(getAllPackCategories.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      }),
});

const { reducer: packCategoryReducer, actions } = packCategorySlice;
const packCategoryActions = { ...actions, getAllPackCategories };

export { packCategoryReducer, packCategoryActions };
